import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import HomePage from '../views/HomePage.vue';
import SignInPage from '../views/SignInPage.vue';
import SignUpPage from '../views/SignUpPage.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/:alias/',
    redirect: '/:alias/sign-up/',
  },
  {
    path: '/:alias/sign-up/',
    name: 'sign-up',
    component: SignUpPage,
  },
  {
    path: '/:alias/sign-in',
    name: 'sign-in',
    component: SignInPage,
  },
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
